import './checkbox.css';

interface CheckboxProps {
    name: string;
    isChecked: boolean;
    label?: string;
    onChange: (id: string, value: boolean) => void;
    isDisabled?: boolean;
    error: string | null;
}

const Checkbox = ({
    name,
    label,
    isChecked,
    onChange,
    isDisabled = false,
    error,
}: CheckboxProps) => {
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.name, event.target.checked);
    };

    return (
        <div className="checkbox-wrapper">
            <label
                htmlFor={name}
                className={`checkbox-control ${isDisabled ? 'is-disabled' : ''}`}
            >
                <input
                    type="checkbox"
                    name={name}
                    id={name}
                    checked={isChecked}
                    onChange={handleOnChange}
                    disabled={isDisabled}
                />
                {label && <span className="checkbox-label">{label}</span>}
            </label>
            {error && <span className="error-message">{error}</span>}
        </div>
    );
};

export default Checkbox;
